import { Component, Input, OnInit, OnChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { TypeAppel } from 'src/app/model/gestion/gestion';
import { DialogConfirmServiceService } from 'src/app/services/dialog-confirm-service.service';
import { GestionTypesAppelsService } from 'src/app/services/http/gestion/gestion-types-appels.service';
import { DialogOverViewComponent } from '../../dialog-over-view/dialog-over-view.component';
import { EditGestionComponent } from '../edit-gestion/edit-gestion/edit-gestion.component';

@Component({
  selector: 'app-gestion-appels-sav',
  templateUrl: './gestion-appels-sav.component.html',
  styleUrls: ['./gestion-appels-sav.component.scss']
})
export class GestionAppelsSavComponent implements OnInit {

  public typesAppelsSavList!: TypeAppel[];
  form !: FormGroup;
  /* Display list */
  displayList: boolean = false;
  /* Message by default on display category list button  */
  message: string = "Afficher la liste";

  messageDialog : string = "";
  addMsg : string = "Élément ajouté";
  itemDeletedSuccessMsg : string = "Élément supprimé";
  itemDeletedFailureMsg : string = "Suppresion impossible";


  get displayedColumn(): string[] {
    const result: string[] = ['nom', 'edit', 'delete'];
    return result;
  }

  newAppelSav: TypeAppel = {
    type_appel_name: "",
  };


  constructor(private service: GestionTypesAppelsService, private builder: FormBuilder, private dialog: MatDialog, private confirmDialog: DialogConfirmServiceService) { }

  ngOnInit() {
    this.loadList();
    this.buildForm();
  }


  buildForm() {

    this.form = this.builder.group({
      nom: ['', Validators.required],
    })
  }


  /* GET the list of types appels sav */
  public loadList() {
    this.service.getTypeAppelsSavList().subscribe(list => {
      this.typesAppelsSavList = list;

       /* Only display type appels with deleted field equal to false. */
     this.typesAppelsSavList =  this.typesAppelsSavList.filter( function (el) {
      return el.deleted == false;
    })

      return this.typesAppelsSavList;
    })
  }

  public onClickVoirListe() {
    this.displayList = !this.displayList;
    if (!this.displayList) {
      this.message = "Afficher la liste";
    } else {
      this.message = "Masquer la liste";
    }

  }

  public onSubmit() {
    this.onCreate();
  }

  public onCreate() {

      this.newAppelSav.type_appel_name = this.form.value.nom;
      this.service.postAppelSav(this.newAppelSav).subscribe((data) => {
        this.messageDialog = this.addMsg;
        this.loadList();
        this.openMessageDialog();
      }, (err) => {
        console.log('ERROR', err);
      })

  }

  public onEdit(appel: TypeAppel) {
    const dialogRef = this.dialog.open(EditGestionComponent, {
      data: {
        id: appel.type_appel_id,
        inputs: ['nom'],
        value: [appel.type_appel_name],
        form: this.form
      }
    });

    dialogRef.afterClosed().subscribe(
      res => {
        if (res != null) {
          let updateCategory: TypeAppel = { type_appel_name: "" };
          updateCategory.type_appel_name = res.values[0];
          updateCategory.type_appel_id = res.values[1];

          this.service.editAppelSav(res.id, updateCategory).subscribe((data) => {
            this.loadList();
          }, (err) => {
            console.log('ERROR', err);
          })

        } 
      }
    )
  }

  public onDelete(id : number, appel: TypeAppel) {
    console.log(appel);
    this.confirmDialog.openConfirmDialog("Voulez-vous supprimer cet élément ?").afterClosed()
    .subscribe(res => {

      if (res) {
        this.service.deleteAppelSav(id, appel).subscribe((data) => {
          this.messageDialog = this.itemDeletedSuccessMsg;
          this.loadList();
          this.openMessageDialog();
        }, (err) => {
          console.log('ERROR', err);
          this.messageDialog = this.itemDeletedFailureMsg;
          this.openMessageDialog();
        })

      }

    });

  }


   /* Alert user when new item is created  */
   public openMessageDialog(): any {
    this.dialog.open(DialogOverViewComponent, {
      width: '20%',
      data: { message: this.messageDialog }
    });
  }
}
